import { createFileRoute } from '@tanstack/react-router';

import { MissionSearchPage } from '@/features/missionSearch/MissionSearchPage';
import { missionSearchParamsSchema } from '@/features/missionSearch/searchParams';

export const Route = createFileRoute('/_app/cases/')({
	validateSearch: missionSearchParamsSchema,
	component: CasesRoute,
});

function CasesRoute() {
	const params = Route.useSearch();
	const navigate = Route.useNavigate();
	return (
		<MissionSearchPage
			params={params}
			onParamsChange={(next) => void navigate({ search: next })}
		/>
	);
}
